import { ACTION_STATES, ComplexAction, createHandler, createReducer, DefaultAction } from "core/actions";
import { assertArray } from "core/validation";
import { deleteFromState } from "../../common";

const logicError = {
    invalidFilmRelease: null,
    advExist: false,
    advToAdd: [],
};
export const initState = {
    advertisers: [],

    advertisementTypes: [],
    primaryRecipient: null,
    ccRecipients: [],
    reportDate: null,
    additionStatus: ACTION_STATES.NO_REQUEST,
    loadingStatus: ACTION_STATES.NO_REQUEST,
    logicError,
    advToReport: [],
    primaryUser: null,
    ccList: [],
    sendingEmail: ACTION_STATES.NO_REQUEST,
};

export class ON_ADD_ADV_TO_REPORT extends ComplexAction {
    successRdx(state, { payload }) {
        return Object.assign({}, state, {
            ...payload,
            additionStatus: ACTION_STATES.SUCCESS,
        });
    }
    failedRdx(state, action) {
        const { payload } = action;
        if (payload.logicError) {
            return Object.assign({}, state, {
                additionStatus: ACTION_STATES.FAILED,
                logicError: payload.logicError,
            });
        } else {
            super.failedRdx(state, payload);
        }
    }
}

export class ON_LOAD_REPORT_VIEW extends ComplexAction {}
export class ON_FILTER_BY_TYPE extends DefaultAction {
    callRdx(state, { payload }) {
        if (payload) {
            const advToReport = state.advertisers.filter((a) => a.advertisementType.id === payload);
            return Object.assign({}, state, {
                advToReport,
            });
        } else {
            return Object.assign({}, state, {
                advToReport: state.advertisers,
            });
        }
    }
}

export class ON_REMOVE_FROM_REPORT extends DefaultAction {
    callRdx(state, { payload }) {
        const toUpdate = deleteFromState(payload, state);
        return Object.assign({}, state, {
            ...toUpdate,
        });
    }
}
export class ON_CLEAR_REPORT extends DefaultAction {
    callRdx() {
        return { ...initState, advertisers: [], advToReport: [] };
    }
}
export class ON_PREVIEW_REPORT extends DefaultAction {}
export class ON_CLEAR_REPORT_ERROR extends DefaultAction {
    callRdx(state) {
        return Object.assign({}, state, {
            logicError,
        });
    }
}

export class ON_ADD_GLOBAL_REPORT extends ComplexAction {}

export class ON_CLEAR_WITH_NEW_FILM_RELEASE extends DefaultAction {
    callRdx(state) {
        return Object.assign({}, state, {
            primaryUser: null,
            ccList: [],
        });
    }
}

export class ON_SEND_REPORT extends ComplexAction {}
export class ON_RESET_EMAIL_SEND_REPORT extends DefaultAction {
    callRdx(state) {
        return Object.assign({}, state, {
            sendingEmail: ACTION_STATES.NO_REQUEST,
            additionStatus: ACTION_STATES.NO_REQUEST,
            loadingStatus: ACTION_STATES.NO_REQUEST,
        });
    }
}
export class ON_ADD_ADV_TO_REPORT_BY_ID extends DefaultAction {}
export const actions = {
    ON_ADD_ADV_TO_REPORT: new ON_ADD_ADV_TO_REPORT({ loadingAtr: "additionStatus" }),
    ON_ADD_ADV_TO_REPORT_BY_ID: new ON_ADD_ADV_TO_REPORT_BY_ID(),
    ON_LOAD_REPORT_VIEW: new ON_LOAD_REPORT_VIEW({ loadingAtr: "loadingStatus" }),
    ON_FILTER_BY_TYPE: new ON_FILTER_BY_TYPE(),
    ON_REMOVE_FROM_REPORT: new ON_REMOVE_FROM_REPORT(),
    ON_CLEAR_REPORT: new ON_CLEAR_REPORT(),
    ON_PREVIEW_REPORT: new ON_PREVIEW_REPORT(),
    ON_CLEAR_REPORT_ERROR: new ON_CLEAR_REPORT_ERROR(),
    ON_CLEAR_WITH_NEW_FILM_RELEASE: new ON_CLEAR_WITH_NEW_FILM_RELEASE(),
    ON_ADD_GLOBAL_REPORT: new ON_ADD_GLOBAL_REPORT({ loadingAtr: "addingGlobalReportStatus" }),
    ON_SET_PRIMARY_USER: new DefaultAction("primaryUser"),
    ON_SET_CC_LIST: new DefaultAction("ccList"),
    ON_SEND_REPORT: new ON_SEND_REPORT({ loadingAtr: "sendingEmail" }),
    ON_RESET_EMAIL_SEND_REPORT: new ON_RESET_EMAIL_SEND_REPORT(),
};

const handlers = createHandler(actions);

export default createReducer(initState, handlers);

export const advertisersSelector = (state) => state.reportAdv.advertisers;
export const filmReleaseSelector = (state) => state.reportAdv.filmRelease;
export const advInLogicErrorSelector = (state) => state.reportAdv.logicError.advToAdd;
export const filmReleaseInLogicErrorSelector = (state) => state.reportAdv.logicError.invalidFilmRelease;

export const advToReportSelector = (state) => {
    return assertArray(state.reportAdv.advToReport) ? state.reportAdv.advToReport : [];
};
